import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=f1011228&scoped=true"
import script from "./Checkout.vue?vue&type=script&setup=true&lang=ts"
export * from "./Checkout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Checkout.vue?vue&type=style&index=0&id=f1011228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1011228",
  null
  
)

export default component.exports